import {
  ExamEventStatsSection,
  LocationAndProctorStatsSection,
  UpcomingExamEventSection,
} from '@exam-center/exam-center-dashboard';
import { useExamCenter } from '@exam-center/exam-center-details';
import { Flex, Grid, Box, Text } from '@shared/components';

export default function ExamCenterHomePage() {
  const { examCenter } = useExamCenter();

  return (
    <Flex
      sx={(theme) => ({
        bgcolor: theme.palette.grey[50],
        flexDirection: 'column',
        height: '100dvh',
        width: '100%',
      })}
    >
      {/* TODO: Extract this to a separate component */}
      <Box
        sx={(theme) => ({
          padding: theme.spacing(8, 6),
        })}
      >
        <Text variant='h1'>ภาพรวมศูนย์สอบ</Text>
        <Text variant='h5' color='text.secondary'>
          {examCenter.code}: {examCenter.nameTH}
        </Text>
      </Box>
      {/* Content */}
      <Grid
        sx={{
          p: (theme) => theme.spacing(6),
          width: '100%',
          gridTemplateColumns: 'repeat(6, 1fr)',
          gap: (theme) => theme.spacing(6),
        }}
      >
        <ExamEventStatsSection sx={{ gridColumn: 'span 4' }} />
        <LocationAndProctorStatsSection sx={{ gridColumn: 'span 2' }} />
        <Box sx={{ gridColumn: 'span 6' }}>
          <UpcomingExamEventSection />
        </Box>
      </Grid>
    </Flex>
  );
}
